export default "__VITE_ASSET__NXnt7Njv__"